module.exports = __webpack_public_path__ + "static/media/2.42f01e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/img/seenapse/others/2.png
// module id = 681
// module chunks = 0